import React from 'react';
import styled from 'styled-components/macro';

export const MOBILE_FOOTER_NAV_SLOT_IDS = ['home', 'films', 'photos', 'models', 'discounts', 'cams', 'join'] as const;

export type MobileFooterNavSlotId = typeof MOBILE_FOOTER_NAV_SLOT_IDS[number];

type MobileFooterNavSlotProps = {
  children: React.ReactNode;
  isVisible?: boolean;
  slotId: MobileFooterNavSlotId;
};

export const MobileFooterNavSlot = (props: MobileFooterNavSlotProps) => {
  const { children, isVisible = true, slotId } = props;

  if (!isVisible) {
    return null;
  }

  return <MobileFooterNavSlotContainer data-slot={slotId}>{children}</MobileFooterNavSlotContainer>;
};

const MobileFooterNavSlotContainer = styled.div`
  display: flex;
  min-width: 0;
`;
